import {tv} from 'tailwind-variants'
import BankSwatch, {type BankSwatchProps} from '../BankSwatch'

const legendItemVariants = tv({
  slots: {
    wrapper: 'flex flex-col gap-s3 border-b border-solid border-border-frosted p-s5',
    keyWrapper:
      'group inline-flex flex-col justify-start gap-s1 sm:flex-row sm:items-center',
  },
  variants: {
    reverseOrientation: {
      true: {
        wrapper: 'text-right',
        keyWrapper: 'items-end text-right sm:flex-row-reverse',
      },
    },
  },
})

type LegendItemProps = {
  label: React.ReactNode
  subLabel: React.ReactNode
  classNames?: {
    wrapper?: string
    keyWrapper?: string
  }
  reverseOrientation?: boolean
} & BankSwatchProps

export const LegendItem = ({
  label,
  subLabel,
  color,
  classNames,
  reverseOrientation,
}: LegendItemProps) => {
  const {wrapper, keyWrapper} = legendItemVariants({
    reverseOrientation,
  })

  return (
    <div className={wrapper({className: classNames?.wrapper})}>
      <div className={keyWrapper({className: classNames?.keyWrapper})}>
        <BankSwatch color={color} />
        <p className="whitespace-nowrap text-text-subdued arcadia-ui-2">{label}</p>
      </div>
      {subLabel && <p className="text-text-default arcadia-heading-5">{subLabel}</p>}
    </div>
  )
}
